import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector:'[nsi-container-content]'
})
export class ContainerContentDirective{
  constructor(public viewContainerRef:ViewContainerRef){}
}
